import { createSelector } from 'reselect';

export const makeGetContainerOrdersByPathParams = () => createSelector(
  [
    (state) => state.containerOrder.containerOrders,
    (_state, props) => Number(props.match.params.orderId),
  ],
  (containerOrders, orderId) => containerOrders.find(o => o.orderId === orderId),
);
